export default __webpack_public_path__ + "static/media/Swap.dc179491.svg";